// extracted by mini-css-extract-plugin
module.exports = {"table":"_1DoSj9nrVomYxUoFlemuik"};